import { AppModalActionType } from '../actiontype/app-modal.actiontype';
import { OtpModalActionType } from '../actiontype/otp-modal.actiontype';
import AuthorizationActionType from '../actiontype/authorization.actiontype';
import ApiStatus from '../constants/api-status.enum';

const initialState = {
    otpFormValidated: false,
    enteredOtp: '',
    invalidOtp: false,
    incorrectOtp: false,
    incorrectResponse: false,
    validateOtpApiStatus: '',
    validateOtpApiResponse: '',
    authLoginApiStatus: '',
    authLoginApiResponse: '',
    enableOtpSection: false
}

export default function(state = initialState, action) {
    switch(action.type) {
        case OtpModalActionType.OTP_FORM_VALIDATED:
        return {
            ...state,
            otpFormValidated: action.payload
        }
        case OtpModalActionType.ENTERED_OTP:
        return {
            ...state,
            enteredOtp: action.payload,
            invalidOtp: false,
            incorrectOtp: false,
            incorrectResponse: false
        }
        case OtpModalActionType.INCORRECT_OTP:
        return {
            ...state,
            invalidOtp: true,
            incorrectOtp: false,
            incorrectResponse: false
        }
        case OtpModalActionType.INCORRECT_OTP_LIMIT:
        return {
            ...state,
            invalidOtp: false,
            incorrectOtp: true,
            incorrectResponse: false
        }
        case OtpModalActionType.INCORRECT_RESPONSE:
        return {
            ...state,
            invalidOtp: false,
            incorrectOtp: false,
            incorrectResponse: true
        }
        case AuthorizationActionType.VALIDATE_OTP_LOADING:
        return {
            ...state,
            validateOtpApiStatus: ApiStatus.LOADING,
            validateOtpApiResponse: action.payload
        }
        case AuthorizationActionType.VALIDATE_OTP_SUCCESS:
        return {
            ...state,
            validateOtpApiStatus: ApiStatus.SUCCESS,
            validateOtpApiResponse: action.payload
        }
        case AuthorizationActionType.VALIDATE_OTP_ERROR:
        return {
            ...state,
            validateOtpApiStatus: ApiStatus.ERROR,
            validateOtpApiResponse: action.payload
        }
        case AuthorizationActionType.AUTH_LOGIN_LOADING:
        return {
            ...state,
            authLoginApiStatus: ApiStatus.LOADING,
            authLoginApiResponse: action.payload
        }
        case AuthorizationActionType.AUTH_LOGIN_SUCCESS:
        return {
            ...state,
            authLoginApiStatus: ApiStatus.SUCCESS,
            authLoginApiResponse: action.payload
        }
        case AuthorizationActionType.AUTH_LOGIN_ERROR:
        return {
            ...state,
            authLoginApiStatus: ApiStatus.ERROR,
            authLoginApiResponse: action.payload
        }
        case OtpModalActionType.ENABLE_OTP_SECTION:
            return { ...state, enableOtpSection: true }
        case AppModalActionType.RESET_MODAL:
        return {
            ...state,
            otpFormValidated: false,
            enteredOtp: '',
            invalidOtp: false,
            incorrectOtp: false,
            enableOtpSection: false,
            incorrectResponse: false
        }
        default:
        return state;
        
    }
}